import _classCallCheck from "C:\\projects\\personal-portfolio\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "C:\\projects\\personal-portfolio\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import { OptionsColor } from "../OptionsColor";
export var Shadow = /*#__PURE__*/function () {
  function Shadow() {
    _classCallCheck(this, Shadow);

    this.blur = 0;
    this.color = new OptionsColor();
    this.enable = false;
    this.offset = {
      x: 0,
      y: 0
    };
    this.color.value = "#000";
  }

  _createClass(Shadow, [{
    key: "load",
    value: function load(data) {
      if (!data) {
        return;
      }

      if (data.blur !== undefined) {
        this.blur = data.blur;
      }

      this.color = OptionsColor.create(this.color, data.color);

      if (data.enable !== undefined) {
        this.enable = data.enable;
      }

      if (data.offset === undefined) {
        return;
      }

      if (data.offset.x !== undefined) {
        this.offset.x = data.offset.x;
      }

      if (data.offset.y !== undefined) {
        this.offset.y = data.offset.y;
      }
    }
  }]);

  return Shadow;
}();